// extracted by mini-css-extract-plugin
export var boldText = "_34-4";
export var checkboxContainer = "_34-6";
export var closeIcon = "_34-g";
export var container = "_34-0";
export var drawer = "_34-8";
export var drawerContent = "_34-9";
export var extraSmallText = "_34-5";
export var fulfillmentGroupTable = "_34-e";
export var largeText = "_34-3";
export var loadingSpinnerContainer = "_34-h";
export var mediumText = "_34-2";
export var narrow = "_34-f";
export var notificationLink = "_34-j";
export var packageCheckIconContainer = "_34-7";
export var slideoutHeaderContainer = "_34-a";
export var slideoutModal = "_34-c";
export var stickyHeaderWrapper = "_34-b";
export var table = "_34-i";
export var tableContainer = "_34-d";
export var tertiaryText = "_34-1";